import { Anchor, Badge, Row, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React from 'react';
import styled from 'styled-components';

import {
  EGateway,
  EPaymentMethod,
  GATEWAY_LABEL,
  NonRedTransactionStatus,
  PAYMENT_METHOD_LABEL,
  TRANSACTION_STATUS_COLORS,
  TRANSACTION_STATUS_LABEL,
} from '../../constants/financial';
import { ETransactionStatus } from '../../constants/financial';
import { useTransactions } from '../../hooks/useCustomerFinancial';
import { Transaction } from '../../types/customer';
import { dateUtils } from '../../utils/dates';
import { stringUtils } from '../../utils/strings';

export type TransactionsTableProps = {
  billingId: number;
};

const { Link } = Anchor;
const DATE_FORMAT = 'dd/MM/yyy HH:mm:ss';
const TransactionsTable: React.FC<TransactionsTableProps> = ({ billingId }) => {
  const { data: transactions, error, isLoading } = useTransactions(billingId);

  if (error) return null;

  const transactionColumns: ColumnsType<Transaction> = [
    {
      title: 'ID Transação',
      dataIndex: 'id',
      key: 'id',
      width: 200,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 200,
      render: (status: NonRedTransactionStatus | ETransactionStatus) => (
        <Row>
          <Badge
            color={
              TRANSACTION_STATUS_COLORS[status as NonRedTransactionStatus] ??
              'red'
            }
            text={TRANSACTION_STATUS_LABEL[status]}
          />
        </Row>
      ),
    },
    {
      title: 'ID da Transação (PSP)',
      dataIndex: 'pspReference',
      key: 'pspReference',
      width: 200,
      render: (pspReference, record) => (
        <CustomLink href={record.pspReferenceLink} title={pspReference} />
      ),
    },
    {
      title: 'Valor Transação',
      dataIndex: 'amount',
      key: 'amount',
      render: amount => (
        <Row style={{ width: '200px' }}>{stringUtils.formatToReal(amount)}</Row>
      ),
      width: 200,
    },
    {
      title: 'Data Criação',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: createdAt => (
        <Row>{dateUtils.formatDateString(createdAt, DATE_FORMAT)}</Row>
      ),
    },
    {
      title: 'Gateway',
      dataIndex: 'gateway',
      key: 'gateway',
      width: 200,
      render: (gateway: EGateway) => (
        <Row>{GATEWAY_LABEL[gateway] ?? gateway}</Row>
      ),
    },
    {
      title: 'Método Pagamento',
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
      width: 200,
      render: (paymentMethod: EPaymentMethod) => (
        <Row>{PAYMENT_METHOD_LABEL[paymentMethod]}</Row>
      ),
    },
    {
      title: 'Dados de pagamento',
      dataIndex: 'paymentData',
      key: 'paymentData',
      width: 200,
      render: (paymentData: Transaction['paymentData']) => {
        if (paymentData?.cardSummary && paymentData.holderName) {
          return (
            <Row>{`${paymentData?.holderName} - ${paymentData?.cardSummary}`}</Row>
          );
        }

        return 'Não se aplica';
      },
    },
    {
      title: 'Merchant Account',
      dataIndex: 'merchantAccount',
      key: 'merchantAccount',
      width: 200,
    },
  ];

  return (
    <Table
      columns={transactionColumns}
      dataSource={transactions}
      rowKey='id'
      pagination={false}
      tableLayout='fixed'
      loading={isLoading}
    />
  );
};

export default TransactionsTable;

const CustomLink = styled(Link)`
  > a {
    color: #1677ff !important;
    text-decoration: underline;
  }
`;
